import axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import {
  fetchFieldNotesFailure,
  fetchFieldNotesStart,
  fetchFieldNotesSuccess,
} from "../../store/features/fieldNotes/fieldNotesSlice";

const URL = buildApiUrl("/api/v1/field_note/field_note/");

const selectAccessToken = (state) => state.auth?.user?.access_token;

const buildQueryParams = (filters = {}) => {
  const params = {};
  const simpleFilters = ["description", "disease", "type", "field", "dates"];

  simpleFilters.forEach((filter) => {
    if (filters[filter]) {
      params[filter] = filters[filter];
    }
  });

  if (
    filters.dates &&
    Array.isArray(filters.dates) &&
    filters.dates.length > 0
  ) {
    params.dates = JSON.stringify(filters.dates);
  }

  return params;
};

const getFieldNotesApi = async (accessToken, filters = {}) => {
  try {
    const params = buildQueryParams(filters);

    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params,
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchFieldNotesSaga(action) {
  try {
    const accessToken = yield select(selectAccessToken);
    const filters = action.payload || {};
    const fieldNotesData = yield call(getFieldNotesApi, accessToken, filters);
    yield put(fetchFieldNotesSuccess(fieldNotesData));
  } catch (error) {
    yield put(fetchFieldNotesFailure(error.message));
  }
}

export default function* fieldNotesSaga() {
  yield takeLatest(fetchFieldNotesStart.type, fetchFieldNotesSaga);
}
